import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import ReactTable from "react-table";
import moment from "moment";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {Link} from "react-router-dom";


export default class LogsTicket extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets_Logs._name, API.RequestType.READ_ALL);
		model.parent = props.parent;
		super(props, model);
		props.parent ? this.request = "GET_SINGLE" : "GET_ALL";
		this.limit = 20;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let	columns = [
				{
					Header: "Ticket Number",
					id: "ticket",
					/** @param {Tickets_Logs_Object} obj */
					accessor: obj => (obj.ticket),
					Cell: (props) => {
						return (
							<span>
							<Link to={`/tickets/${props.original.ticket}`}>
								{props.original.ticket}
							</Link>
						</span>
						)
					}
				},
				{
					Header: "Date Changed",
					id: "date",
					/** @param {Tickets_Logs_Object} obj */
					accessor: obj => {
						return obj.date ? moment(obj.date).local().format("MM/DD/YYYY h:mm a") : '-'
					}
				},
				{
					Header: "User",
					id: "user",
					/** @param {Tickets_Logs_Object} obj */
					accessor: obj => (obj.users ? (obj.users.name_first + " " + obj.users.name_last) : "Admin")
				},
				{
					Header: "Field",
					id: "field",
					/** @param {Tickets_Logs_Object} obj */
					accessor: obj => (obj.field.replace("_", " "))
				},
				{
					Header: "Original",
					id: "value_original",
					/** @param {Tickets_Logs_Object} obj */
					accessor: obj => (obj.display_original ? obj.display_original : (obj.value_original ? obj.value_original : "Blank"))
				},
				{
					Header: "New",
					id: "value_new",
					/** @param {Tickets_Logs_Object} obj */
					accessor: obj => (obj.display_new ?? obj.value_new)
				},
				{
					Header: "Note",
					id: "note",
					/** @param {Tickets_Logs_Object} obj */
					accessor: obj => (obj.note)
				},
			];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Ticket Logs')}
							{this.renderHeaderRight("Ticket Logs", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
